// Traduções dos rótulos derivados de códigos da trilha de auditoria.
export default {
  pt: {
    'audit.labels.resource.user': 'Usuário',
    'audit.labels.resource.audit': 'Auditoria',
    'audit.labels.resource.shipment': 'Carga',
    'audit.labels.resource.contract': 'Contrato',
    'audit.labels.resource.fleet': 'Frota',
    'audit.labels.resource.fleetCategory': 'Categoria de frota',
    'audit.labels.resource.personnel': 'Pessoal',
    'audit.labels.resource.customer': 'Cliente',
    'audit.labels.resource.place': 'Local',
    'audit.labels.resource.pair': 'Dupla',
    'audit.labels.resource.set': 'Conjunto',
    'audit.labels.resource.machineTransport': 'Transporte de máquina',
    'audit.labels.resource.ticket': 'Ticket',
    'audit.labels.resource.transfer': 'Transferência',
    'audit.labels.resource.import': 'Importação',
    'audit.labels.resource.category': 'Categoria',
    'audit.labels.resource.permission': 'Permissão',
    'audit.labels.resource.deviation': 'Desvio',
    'audit.labels.resource.keyboardMessage': 'Mensagem do teclado',
    'audit.labels.verb.create': 'Criação',
    'audit.labels.verb.update': 'Edição',
    'audit.labels.verb.delete': 'Exclusão',
    'audit.labels.verb.view': 'Consulta',
    'audit.labels.verb.export': 'Exportação',
    'audit.labels.verb.import': 'Importação',
    'audit.labels.verb.activate': 'Ativação',
    'audit.labels.verb.deactivate': 'Desativação',
    'audit.labels.verb.login': 'Login',
    'audit.labels.verb.logout': 'Saída',
    'audit.labels.action.login': 'Login',
    'audit.labels.action.logout': 'Saída',
    'audit.labels.action.changePassword': 'Troca de senha',
    'audit.labels.action.forgotPassword': 'Solicitação de recuperação de senha',
    'audit.labels.action.resetPassword': 'Redefinição de senha',
    'audit.labels.action.activateAccount': 'Ativação de conta',
    'audit.labels.action.mfaChallenge': 'Desafio de segundo fator emitido',
    'audit.labels.action.mfaVerify': 'Verificação de segundo fator',
    'audit.labels.action.mfaSetup': 'Início da configuração do segundo fator',
    'audit.labels.action.mfaEnabled': 'Segundo fator ativado',
    'audit.labels.action.mfaDisabled': 'Segundo fator desativado',
    'audit.labels.action.mfaRecovery': 'Uso de código de recuperação',
    'audit.labels.action.mfaCodesRegenerated': 'Códigos de recuperação regerados',
    'audit.labels.action.auditView': 'Consulta da auditoria',
    'audit.labels.action.auditExport': 'Exportação da auditoria',
    'audit.labels.action.keyboardMessageCheck': 'Conferência de mensagem do teclado',
    'audit.labels.actionOf': '{{action}} de {{resource}}',
  },
  en: {
    'audit.labels.resource.user': 'User',
    'audit.labels.resource.audit': 'Audit',
    'audit.labels.resource.shipment': 'Load',
    'audit.labels.resource.contract': 'Contract',
    'audit.labels.resource.fleet': 'Fleet',
    'audit.labels.resource.fleetCategory': 'Fleet category',
    'audit.labels.resource.personnel': 'Personnel',
    'audit.labels.resource.customer': 'Customer',
    'audit.labels.resource.place': 'Place',
    'audit.labels.resource.pair': 'Pair',
    'audit.labels.resource.set': 'Set',
    'audit.labels.resource.machineTransport': 'Machine transport',
    'audit.labels.resource.ticket': 'Ticket',
    'audit.labels.resource.transfer': 'Transfer',
    'audit.labels.resource.import': 'Import',
    'audit.labels.resource.category': 'Category',
    'audit.labels.resource.permission': 'Permission',
    'audit.labels.resource.deviation': 'Deviation',
    'audit.labels.resource.keyboardMessage': 'Keyboard message',
    'audit.labels.verb.create': 'Creation',
    'audit.labels.verb.update': 'Update',
    'audit.labels.verb.delete': 'Deletion',
    'audit.labels.verb.view': 'View',
    'audit.labels.verb.export': 'Export',
    'audit.labels.verb.import': 'Import',
    'audit.labels.verb.activate': 'Activation',
    'audit.labels.verb.deactivate': 'Deactivation',
    'audit.labels.verb.login': 'Login',
    'audit.labels.verb.logout': 'Logout',
    'audit.labels.action.login': 'Login',
    'audit.labels.action.logout': 'Logout',
    'audit.labels.action.changePassword': 'Password change',
    'audit.labels.action.forgotPassword': 'Password recovery request',
    'audit.labels.action.resetPassword': 'Password reset',
    'audit.labels.action.activateAccount': 'Account activation',
    'audit.labels.action.mfaChallenge': 'Two-factor challenge issued',
    'audit.labels.action.mfaVerify': 'Two-factor verification',
    'audit.labels.action.mfaSetup': 'Two-factor setup started',
    'audit.labels.action.mfaEnabled': 'Two-factor authentication enabled',
    'audit.labels.action.mfaDisabled': 'Two-factor authentication disabled',
    'audit.labels.action.mfaRecovery': 'Recovery code used',
    'audit.labels.action.mfaCodesRegenerated': 'Recovery codes regenerated',
    'audit.labels.action.auditView': 'Audit viewed',
    'audit.labels.action.auditExport': 'Audit exported',
    'audit.labels.action.keyboardMessageCheck': 'Keyboard message checked',
    'audit.labels.actionOf': '{{action}} of {{resource}}',
  },
  es: {
    'audit.labels.resource.user': 'Usuario',
    'audit.labels.resource.audit': 'Auditoría',
    'audit.labels.resource.shipment': 'Carga',
    'audit.labels.resource.contract': 'Contrato',
    'audit.labels.resource.fleet': 'Flota',
    'audit.labels.resource.fleetCategory': 'Categoría de flota',
    'audit.labels.resource.personnel': 'Personal',
    'audit.labels.resource.customer': 'Cliente',
    'audit.labels.resource.place': 'Lugar',
    'audit.labels.resource.pair': 'Pareja',
    'audit.labels.resource.set': 'Conjunto',
    'audit.labels.resource.machineTransport': 'Transporte de máquina',
    'audit.labels.resource.ticket': 'Ticket',
    'audit.labels.resource.transfer': 'Transferencia',
    'audit.labels.resource.import': 'Importación',
    'audit.labels.resource.category': 'Categoría',
    'audit.labels.resource.permission': 'Permiso',
    'audit.labels.resource.deviation': 'Desvío',
    'audit.labels.resource.keyboardMessage': 'Mensaje de teclado',
    'audit.labels.verb.create': 'Creación',
    'audit.labels.verb.update': 'Edición',
    'audit.labels.verb.delete': 'Eliminación',
    'audit.labels.verb.view': 'Consulta',
    'audit.labels.verb.export': 'Exportación',
    'audit.labels.verb.import': 'Importación',
    'audit.labels.verb.activate': 'Activación',
    'audit.labels.verb.deactivate': 'Desactivación',
    'audit.labels.verb.login': 'Inicio de sesión',
    'audit.labels.verb.logout': 'Cierre de sesión',
    'audit.labels.action.login': 'Inicio de sesión',
    'audit.labels.action.logout': 'Cierre de sesión',
    'audit.labels.action.changePassword': 'Cambio de contraseña',
    'audit.labels.action.forgotPassword': 'Solicitud de recuperación de contraseña',
    'audit.labels.action.resetPassword': 'Restablecimiento de contraseña',
    'audit.labels.action.activateAccount': 'Activación de cuenta',
    'audit.labels.action.mfaChallenge': 'Desafío de segundo factor emitido',
    'audit.labels.action.mfaVerify': 'Verificación de segundo factor',
    'audit.labels.action.mfaSetup': 'Inicio de la configuración del segundo factor',
    'audit.labels.action.mfaEnabled': 'Segundo factor activado',
    'audit.labels.action.mfaDisabled': 'Segundo factor desactivado',
    'audit.labels.action.mfaRecovery': 'Uso de código de recuperación',
    'audit.labels.action.mfaCodesRegenerated': 'Códigos de recuperación regenerados',
    'audit.labels.action.auditView': 'Consulta de la auditoría',
    'audit.labels.action.auditExport': 'Exportación de la auditoría',
    'audit.labels.action.keyboardMessageCheck': 'Revisión de mensaje de teclado',
    'audit.labels.actionOf': '{{action}} de {{resource}}',
  },
}
